'use client'

import { Button, Modal } from 'flowbite-react'
import { ExclamationCircle } from 'flowbite-react-icons/solid'
import { useState } from 'react'

interface TeamProps {
  isLeader: boolean
  isMember: boolean
  isfirstRoundEnded: boolean
  submissionStatus: 'none' | 'draft' | 'qualified' | 'disqualified'
  deleteTeam: () => void
  leaveTeam: () => void
}
export const TeamAction = ({
  isLeader,
  isMember,
  isfirstRoundEnded,
  submissionStatus,
  deleteTeam,
  leaveTeam,
}: TeamProps) => {
  const [openModal, setOpenModal] = useState(false)

  if (
    (!isLeader && !isMember) ||
    isfirstRoundEnded ||
    (submissionStatus !== 'draft' && submissionStatus !== 'none')
  ) {
    return null
  }

  const onModalConfirm = () => {
    if (isLeader) {
      deleteTeam()
    } else {
      leaveTeam()
    }
    setOpenModal(false)
  }

  return (
    <>
      <div className="p-5 my-5 space-y-2 border border-red-200 rounded-lg">
        <div className="flex flex-row">
          <ExclamationCircle className="w-5 h-5 mr-1 text-red-800" />
          <p className="text-red-800 font-semibold text-base">
            {isMember && 'Leave Team'}
            {isLeader &&
              submissionStatus === 'draft' &&
              'Delete Team and Submission'}
            {isLeader && submissionStatus === 'none' && 'Delete Team'}
          </p>
        </div>
        <p className="text-sm text-red-800">
          {isMember && 'You will no longer be a part of this team.'}
          {isLeader &&
            submissionStatus === 'draft' &&
            'You will lose any progress made on your submission. If you have added any team members, they will be removed from the team and also lose access to the submission.'}
          {isLeader &&
            submissionStatus === 'none' &&
            'If you have added any team members, they will be removed from the team and no longer be part of the submission.'}
        </p>
        <Button
          color="failure"
          className="bg-red-700"
          onClick={() => setOpenModal(true)}
        >
          {isMember && 'Leave Team'}
          {isLeader &&
            submissionStatus === 'draft' &&
            'Delete Team and Submission'}
          {isLeader && submissionStatus === 'none' && 'Delete Team'}
        </Button>
      </div>

      <Modal
        show={openModal}
        size="lg"
        onClose={() => setOpenModal(false)}
        popup
      >
        <Modal.Header />
        <Modal.Body>
          <div className="text-center">
            <h3 className="mb-1 text-lg font-semibold text-gray-900 dark:text-gray-400">
              {isLeader ? 'Delete' : 'Leave'} Team ?
            </h3>
            <p className="mb-5 text-base text-gray-500 dark:text-gray-400">
              This action cannot be undone. Please be certain.
            </p>
            <div className="flex justify-center gap-4">
              <Button color="gray" onClick={() => setOpenModal(false)}>
                No, cancel
              </Button>
              <Button color="failure" onClick={onModalConfirm}>
                {isLeader ? 'Yes, Delete' : 'Yes, Leave'}
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  )
}
